"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contains = exports.equalLists = exports.Counter = void 0;
var Counter = (function () {
    function Counter() {
        this.value = 0;
    }
    Counter.prototype.increment = function () {
        return this.value++;
    };
    return Counter;
}());
exports.Counter = Counter;
function equalLists(arr1, arr2) {
    if (arr1.length == arr2.length) {
        for (var i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i])
                return false;
        }
        return true;
    }
    return false;
}
exports.equalLists = equalLists;
function contains(list, element) {
    return list.indexOf(element) > -1;
}
exports.contains = contains;
